<h2 mat-dialog-title>
  <mat-icon>percent_discount</mat-icon>
  Rediger rabattype for adgangsgrupper
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog" (click)="close()">
  <mat-icon class="material-icons">close</mat-icon>
</button>
@if (response$ | async; as response) {
  <form [formGroup]="formGroup">
    <mat-dialog-content>
      <ok-feedback-info>
        <div>
          Rabattypen bliver ændret fra <strong>{{ data.existingDiscountType | translateOrganizationDiscountType }}</strong> til
          <strong>{{ data.existingDiscountType !== DiscountType.Percentages ? '%' : 'kr.' }}</strong> for alle adgangsgrupper under
          <strong>{{ data.organizationName }}.</strong>
          Der skal tages stilling til nye rabat værdier for hver adgangsgruppe nedenfor.
        </div>
      </ok-feedback-info>
      @if (response[1]; as accessGroups) {
        <div class="row-container">
          <div>
            <strong>Adgangsgruppe</strong>
          </div>
          <div class="align-right">
            <strong>Rabat</strong>
          </div>
          <div>
            <strong>Ny rabat</strong>
          </div>
        </div>
        <div formArrayName="accessGroups">
          @for (identifier of formGroup.controls.accessGroups.controls; track $index; let i = $index) {
            <div class="row-container">
              <div>
                {{ accessGroups[i].name }}
              </div>

              <div class="current-discount">
                @if (accessGroups[i].sharedDiscountIdentifier) {
                  <mat-icon
                    svgIcon="icon_transverse_discount"
                    class="orange"
                    [matTooltip]="'Tværgående rabat: ' + accessGroups[i].sharedDiscountName"></mat-icon>
                }
                {{ accessGroups[i].amount }} {{ data.existingDiscountType | translateOrganizationDiscountType }}
              </div>

              <div [formGroupName]="i" class="flex align-center gap-6">
                <mat-form-field [subscriptSizing]="'dynamic'">
                  <mat-label>Værdi</mat-label>
                  <input type="text" matInput [inputMask]="priceInputMask" formControlName="amount" />
                  @if (formGroup.controls.accessGroups.controls[i].hasError('required')) {
                    <mat-error>
                      <div>Indtast venligst en rabat.</div>
                    </mat-error>
                  }
                  @if (
                    formGroup.controls.accessGroups.controls[i].hasError('min') ||
                    formGroup.controls.accessGroups.controls[i].hasError('max')
                  ) {
                    <mat-error>
                      <div>Rabatten skal være en værdi mellem 0 og 100</div>
                    </mat-error>
                  }
                  <span class="margin--left-xs" matTextSuffix>{{
                    data.existingDiscountType !== DiscountType.Percentages ? '%' : 'kr.'
                  }}</span>
                </mat-form-field>
                <span>eller</span>
                <mat-form-field [matTooltip]="'Vælg tværgående rabat'" subscriptSizing="dynamic">
                  <mat-label>Vælg tværgående rabat</mat-label>
                  <mat-select formControlName="sharedAccessGroupDiscountIdentifier" okCustomDropDownArrowDirective>
                    <mat-option [value]="null">Ingen tværgående rabat</mat-option>
                    @for (discount of response[0]; track discount.identifier) {
                      <mat-option [value]="discount.identifier">
                        {{ discount.name }} {{ discount.amount }} {{ discount.discount_type === DiscountType.Percentages ? '%' : 'kr.' }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-icon matSuffix></mat-icon>
                </mat-form-field>
              </div>
            </div>
          }
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="close()">Annuller</button>
      <button mat-raised-button color="primary" (click)="submit()" [disabled]="formGroup.controls.accessGroups.errors?.allOrNoneSet">
        Opdater rabattype
      </button>
    </mat-dialog-actions>
  </form>
}
